import i18next from 'i18next';

import LangApiRepository from './repositories/LangApiRepository';
import LangLocalRepository from './repositories/LangLocalRepository';
import { LangTypeEnum } from './types/Lang';

export default class LangService {
  langApi: LangApiRepository;
  langLocal: LangLocalRepository;

  constructor() {
    this.langApi = new LangApiRepository();
    this.langLocal = new LangLocalRepository();
  }

  changeLang = async (lang: LangTypeEnum) => {
    this.langApi.setLanguage(lang);
    this.langLocal.set(lang);

    if (lang) {
      await i18next.changeLanguage(lang);
    }
  };

  getLang = () => {
    return this.langLocal.get();
  };
}
